import { createContext, useContext } from 'react';

// Create a context
const AppContext = createContext();

export function useAppContext() {
  return useContext(AppContext);
}

export default AppContext;
